module.exports = __webpack_public_path__ + "static/media/SchoolCosContImprove.5a4c7c65.png";